<template>
  <v-card outlined>
    <v-card-title class="text-subtitle-1 font-weight-bold">
      Métricas&nbsp;
      <v-icon>mdi-chart-scatter-plot</v-icon>
    </v-card-title>
    <v-card-text>
      <v-container class="pa-0">
        <v-row v-if="stats.length > 0">
          <v-col cols="12" md="3" v-for="stat in stats" :key="stat.id">
            <v-card rounded class="d-block mx-auto" outlined>
              <v-card-title class="justify-center">
                <p class="text-left titulo mb-0">
                  <v-icon small class="pb-1">{{ stat.icono }}</v-icon>
                  {{ stat.titulo }}:
                  <span v-if="stat.formato == 'porc'"
                    >{{ stat.numero | number }}&nbsp;%</span
                  >
                  <span v-if="stat.formato == 'currency'">{{
                    stat.numero | number
                  }}</span>
                  <span v-if="stat.formato == 'number'">{{
                    stat.numero | number
                  }}</span>
                </p>
              </v-card-title>
              <v-card-text>
                <v-container fluid class="pa-0">
                  <v-row>
                    <v-col cols="12" class="comparado with-icon py-0">
                      <v-icon
                        v-if="stat.numeroComparacion > 0"
                        color="green"
                        small
                        >mdi-arrow-top-right</v-icon
                      >
                      <v-icon
                        v-if="stat.numeroComparacion < 0"
                        color="red"
                        small
                        >mdi-arrow-bottom-right</v-icon
                      >
                      <span
                        v-bind:class="{
                          'red-text': stat.numeroComparacion < 0,
                          'green-text': stat.numeroComparacion > 0,
                        }"
                        >{{ stat.numeroComparacion | number }} %</span
                      >
                    </v-col>
                    <v-col cols="12" class="text-justify">
                      <p class="comparado mb-0">
                        Comparado con el periodo anterior
                      </p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-container v-else class="text-center pt-0">
          No hay métricas disponibles (&gt;.&lt;)
        </v-container>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { subMonths, startOfMonth, endOfMonth } from "date-fns";
import { httpPost } from "../../services/apiService";

export default {
  data() {
    return {
      stats: [],
    };
  },

  methods: {
    async getData() {
      this.overlay = true;
      const prevMonth = subMonths(new Date(), 1);
      const body = {
        vendedor: JSON.parse(sessionStorage.getItem("user"))["id"],
        initMonth: startOfMonth(new Date()).toISOString(),
        endMonth: endOfMonth(new Date()).toISOString(),
        prevInitMonth: startOfMonth(prevMonth).toISOString(),
        prevEndMonth: endOfMonth(prevMonth).toISOString(),
      };
      const { data } = await httpPost("/cotizacion/dashboard-data", {
        data: body,
      });
      this.stats = [
        {
          id: 1,
          titulo: "Total Cotizaciones",
          numero: data?.totalCotizaciones,
          formato: "number",
          icono: "mdi-update",
          numeroComparacion: data?.changeTotalCotizaciones,
        },
        {
          id: 3,
          titulo: "Total Cotizado",
          numero: data?.totalFacturado,
          formato: "currency",
          icono: "mdi-currency-usd",
          numeroComparacion: data?.changeTotalFacturado,
        },
        {
          id: 4,
          titulo: "Total Clientes",
          numero: data?.totalClientes,
          formato: "number",
          icono: "mdi-account-group",
          numeroComparacion: data?.changeTotalClientes,
        },
        {
          id: 2,
          titulo: "Total Entregadas",
          numero: data?.totalEntregadas,
          formato: "porc",
          icono: "mdi-percent",
          numeroComparacion: data?.changeTotalEntregadas,
        },
      ];
      this.overlay = false;
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss">
.green-text {
  color: green;
}
.red-text {
  color: red;
}
.titulo {
  font-size: 0.8rem;
  font-weight: bold;
  margin-bottom: 0;
}
.comparado {
  font-size: 0.75rem;
  font-weight: bold;
}
.with-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>